import { createSelector } from 'reselect';

export const getPrivateChannel = () => createSelector(
  (state) => (state) ? state.channels : null,
  (channels) => channels && channels.filter(c => c.channel_type === 'private')
)

export const getFeeds = (state) => createSelector(
  () => {
    return (state && state.feeds) ? state.feeds.news : null
  }
)



// WEBPACK FOOTER //
// ./src/features/common/redux/selector.js